var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141.63,
    height: 77.66,
    viewBox: "0 0 151 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x99\x94\xEC\x82\xB4\xED\x91\x9C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 39",
    d: "M4.66406 43.1401H143.286",
    stroke: "#04DB8F",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 41",
    d: "M146.293 43.4136L105.7 82.0742",
    stroke: "#04DB8F",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 42",
    d: "M105.699 4.41406L146.292 43.0747",
    stroke: "#04DB8F",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/화살표.1b3c8a2cd45baa317061fcdb4f331c17.svg";
export { ForwardRef as ReactComponent };